module.exports = __webpack_public_path__ + "public/stars-rewards-open-chest-anim-108px.png";